import { useRecoilValue } from 'recoil'
import userSelectors from '@/pages/User/user.selectors.ts'

const useSelfAccessRightsSet = () => {
  return useRecoilValue(userSelectors.selectAccessRightsSet)
}

export default useSelfAccessRightsSet
